<template>
  <div class="bg-white" id="container">
    <div class="lg:container p-5">

      <div class="my-6">
        <location :isEditButton="true" :is-border="true" />
      </div>

      <h2 class="font-bold">Your deal</h2>
      <section class="md:flex">
        <!-- Wizard start here  -->
        <div class="w-8/12 h-full w-full">
          <form-wizard class="w-full" color="#16a34a" title="" subtitle="" finishButtonText="Book Now"
            @on-complete="formSubmitted"><!-- tab 1 content -->
            <tab-content title="Your Deal" class="mb-5">
              <div class="vx-row">
                <div class="flex items-center border border-solid bg-green-50 border-green-600 w-full p-6 rounded-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" class="w-5 h-5" style="fill: green">
                    <path
                      d="M56.62 93.54a4 4 0 0 1-2.83-1.18L28.4 67a4 4 0 1 1 5.65-5.65l22.13 22.1 33-44a4 4 0 1 1 6.4 4.8L59.82 91.94a4.06 4.06 0 0 1-2.92 1.59zM128 64c0-35.346-28.654-64-64-64C28.654 0 0 28.654 0 64c0 35.346 28.654 64 64 64 35.33-.039 63.961-28.67 64-64zm-8 0c0 30.928-25.072 56-56 56S8 94.928 8 64 33.072 8 64 8c30.914.033 55.967 25.086 56 56z">
                    </path>
                  </svg>

                  <p class="ml-5 text-black">
                    Free cancellation up to 48 hours before pick-up
                  </p>
                </div>
                <!-- Car details card  -->
                <cardCarDetails :item="this.$store.state.main.currentCarSelected" class="w-full mt-3" cardStyles=" ">
                </cardCarDetails>

                <!-- Extras section  -->
                <div>
                  <h3 class="font-bold">Extras</h3>
                  <p class="mt-3">Child seats, additional drivers and more.</p>
                  <p class="cursor-pointer text-blue-600 mt-3 hover:underline" @click="isAddExtras = true">
                    Add extras
                  </p>
                  <vs-popup class="holamundo" title="Add extras (optional)" :active.sync="isAddExtras">
                    <div class="p-2">
                      <!-- extras component  -->
                      <extras></extras>

                      <p class="mt-3">
                        Please note: If you request any extras that are payable at
                        pick-up, we can’t guarantee that you’ll get them, or that
                        their prices will be the same as the prices you see here.
                      </p>
                      <div class="flex justify-end mt-8">
                        <vs-button @click="isAddExtras = false" color="primary" type="filled">Add Extras</vs-button>
                      </div>
                    </div>
                  </vs-popup>
                </div>
              </div>
            </tab-content>

            <!-- tab 2 content -->
            <tab-content title="Checkout" class="mb-5">
              <div class="vx-row">
                <h4 class="font-bold mb-5">
                  Protection...
                  <span class="text-primary">for peace of mind</span>
                </h4>
                <p class="mb-4">
                  At the counter, the car hire company will block a deposit amount
                  on your credit card. You could lose your whole deposit if the
                  car is damaged or stolen, but as long as you have our Full
                  Protection, Rentalcover.com will refund you! (The protection
                  price you see includes all applicable taxes and fees).
                </p>
                <p class="mb-4">
                  T&Cs and standard exclusions apply. Please read:
                </p>
                <div class="w-full">
                  <a href="https://rentalcover.com/pds/NQDQ-TQ5J-INS" target="_blank">Protection Terms</a>
                </div>

                <dropDown class="mt-6" />

                <!-- ------------------ -->
                <div
                  class="flex items-center border border-solid bg-orange-50 border-orange-300 w-full p-6 rounded-lg mt-10">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6" style="fill: #923e01">
                    <path
                      d="M14.25 15.75h-.75a.75.75 0 0 1-.75-.75v-3.75a1.5 1.5 0 0 0-1.5-1.5h-.75a.75.75 0 0 0 0 1.5h.75V15a2.25 2.25 0 0 0 2.25 2.25h.75a.75.75 0 0 0 0-1.5zM11.625 6a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25.75.75 0 0 0 0 1.5.375.375 0 1 1 0-.75.375.375 0 0 1 0 .75.75.75 0 0 0 0-1.5zM22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12zm1.5 0c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12 12-5.373 12-12z">
                    </path>
                  </svg>

                  <p class="ml-5 text-black">
                    <strong>Please note: </strong> Your own car insurance is
                    unlikely to cover hire cars.
                  </p>
                </div>
              </div>
            </tab-content>

            <!-- tab 3 content -->
            <tab-content title="Booking" class="mb-5">
              <!-- driverDetails -->
              <section class="vx-row shadow rounded-lg">
                <driverDetails class="m-3" />
              </section>
              <!-- billing Address -->
              <!-- <section class="vx-row shadow rounded-lg mt-8">
              <billingAddress class="m-3" />
            </section> -->
              <!-- Credit Card   -->
              <!-- <section class="vx-row shadow rounded-lg mt-8">
              <CreditCard class="m-3" />
            </section> -->
              <!-- Terms and conditions  -->
              <section class="vx-row shadow rounded-lg mt-8">
                <termsAndCondition class="m-3" />
              </section>
            </tab-content>
          </form-wizard>
        </div>

        <div class="md:w-4/12 h-full w-full">
          <!-- Right sectio timeline  -->
          <div class="p-4 rounded-lg border border-solid border-gray-200 mx-3">
            <h2 class="text-xl font-bold mb-4">Pick-up and drop-off</h2>
            <div class="relative">
              <div class="timeline">
                <div class="flex items-start mb-4">
                  <!-- first circle  -->
                  <div class="h-4 w-4 mt-1 rounded-full border-2 border-solid border-black flex-shrink-0"></div>
                  <div class="ml-4">
                    <p class="text-sm font-bold">
                      {{ $store.state.main.bookingDetails.formData.pickupPlace }}
                    </p>
                    <p class="text-sm">{{ formattedDateTime.pickupDateTime }}</p>
                  </div>
                </div>
                <div class="flex items-start mt-20">
                  <!-- second circle  -->
                  <div class="h-4 w-4 mt-1 rounded-full border-2 border-solid border-black flex-shrink-0"></div>
                  <div class="ml-4">
                    <p class="text-sm font-bold">
                      {{ $store.state.main.bookingDetails.formData.dropOffPlace }}
                    </p>
                    <p class="text-sm">{{ formattedDateTime.dropoffDateTime }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Pricing  -->
          <div class="p-4 rounded-lg border border-solid border-gray-200 mx-3 mt-5">
            <h2 class="text-xl font-bold mb-4">Car price breakdown</h2>
            <div class="flex justify-between">
              <section>Car hire charge <small> {{ selectedCar.Charges.Calculation.UnitAmount }} x {{
                selectedCar.Charges.Calculation.Quantity }}</small></section>
              <section class="text-black">
                RM {{ carRentPrice.toFixed(2) }}
              </section>
            </div>
            <vs-divider />

            <div v-if="extras">
              <section v-for="(item, index) in extras" :key="index">
                <div class="flex justify-between">
                  <section>{{ item.Description }}</section>
                  <section class="text-black">
                    RM {{ (item.Total * item.Quantity).toFixed(2) }}
                  </section>
                </div>
                <vs-divider />
              </section>
            </div>

            <div v-if="requiredExtras">
              <section v-for="(item, index) in requiredExtras" :key="index">
                <div class="flex justify-between">
                  <section>{{ item.AdditionalInfo }} {{ item.Functionality }}</section>
                  <section class="text-black">
                    RM {{ (item.Charge * item.Quantity).toFixed(2) }}
                  </section>
                </div>
                <vs-divider />
              </section>
            </div>
            <div class="flex justify-between">
              <section class="font-bold text-black">
                Price for {{ calculateTotalPrice().days }} days:
              </section>
              <section class="font-bold text-black">
                RM {{ formatPrice(calculateTotalPrice().totalPrice.toFixed(2)) }}
              </section>
            </div>
          </div>

          <vs-button @click="onComplete" class="md:hidden w-full my-6" color="primary" type="filled">Book Now</vs-button>
        </div>
      </section>
    </div>
    <!-- <pre>$store.state.main.reservationData  {{ $store.state.main.reservationData }}</pre> -->
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import { mapState } from "vuex";
import { alertMixin } from "@/mixin/alertMixin";
import { axiosMixin } from "@/mixin/axiosMixin";
import { helperMixin } from "@/mixin/helperMixin";

import cardCarDetails from "@/components/hawk/cardCarDetails.vue";
import location from "@/components/hawk/location.vue";
import extras from "@/components/hawk/extras.vue";
import dropDown from "@/components/hawk/dropDown.vue";
import driverDetails from "@/components/hawk/driverDetails.vue";
import billingAddress from "@/components/hawk/billingAddress.vue";
import CreditCard from "../../components/hawk/creditCard.vue";
import termsAndCondition from "../../components/hawk/termsAndCondition.vue";
export default {
  mixins: [alertMixin, axiosMixin, helperMixin],

  data() {
    return {
      extras: [],
      isReady: false,
      isAddExtras: false,
      selectedCar: this.$store.state.main.currentCarSelected,
      requiredExtras: this.$store.state.main.currentCarSelected.RequiredExtras,
      carRentPrice: 0,
      // totalDays: this.$store.state.main.pickUpAndDropOffTiming.totalDays,
      // extraHours: this.$store.state.main.pickUpAndDropOffTiming.extraHours,
    };
  },
  watch: {
    storeExtras: {
      handler(extras) {
        this.extras = extras.filter((extra) => extra.Quantity > 0);
        this.calculateTotalPrice();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    startLoading() {
      this.$vs.loading({
        container: "#container",
        scale: 0.6,
      });
    },
    stopLoading() {
      this.$vs.loading.close("#container > .con-vs-loading");
    },
    onComplete() {
      this.$router.replace("/confirmation");
    },
    formSubmitted() {
      const driverInfo = this.$store.state.main.bookingDetails.driverInfo;
      const requiredFields = ['clientName', 'clientSurname', 'clientEmail', 'clientMobile',
      'clientDrLicense','phonePrefix','title','gender','country','issueingCountry','clientDob','clientConfirmEmail'];
      if (this.$store.state.main.bookingDetails.isAirportCharge) {
        requiredFields.push('clientArrivalDate', 'flightArrivalNumber');
      }
      const isEmpty = requiredFields.some(field => !driverInfo[field]);
      if (isEmpty) {
        alert("Please fill in all the fields");
        return;
      }
      var data = this.$store.state.main.bookingDetails;
      var currentCarSelected = this.$store.state.main.currentCarSelected;
      var extras = this.$store.state.main.extras;
      const { Code, Quantity } = this.extras;

      const newExtras = this.extras.map(({ Code, Quantity }) => ({ Code, Quantity }));

      console.log("old extras :", this.extras)
      console.log("extras:", newExtras)
      console.log("currentCarSelected:", currentCarSelected)
      console.log("data:", data)

      var refNo = data.driverInfo.clientName + data.formData.pickupDate.replace(/-/g, "");

      refNo = refNo.replace(/\s/g, "").toUpperCase();
      const randomFiveDigit = Math.floor(10000 + Math.random() * 90000);
      const payLoad = {
        "ReferenceNo": refNo + randomFiveDigit,
        "VoucherNo": "",
        "PaymentMethod": "Local",
        "ClientNo": "",
        "ClientSalutation": data.driverInfo.title,
        "ClientName": data.driverInfo.clientName,
        "ClientSurname": data.driverInfo.clientSurname,
        "ClientGender":  data.driverInfo.gender,
        "ClientDrLicense": data.driverInfo.clientDrLicense,
        "DrivLicIssuedIn": data.driverInfo.issueingCountry,
        "ClientNationality": data.driverInfo.country,
        "ClientTel": "",
        "ClientMobile": data.driverInfo.clientMobile,
        "ClientEmail": data.driverInfo.clientEmail,
        "ClientDrSkills": "Both",
        "ClientDOB":  data.driverInfo.clientDob,
        "ClientAgeOnCounter": "",
        "ClientRoom": "",
        "ClientArrival": data.formData.pickupDate + " " + data.formData.pickupTime,
        "ClientDeparture": data.formData.dropoffDate + " " + data.formData.dropoffTime,
        "FlightArrival": data.driverInfo.flightArrivalNumber,
        "FlightDeparture": "",
        "VehicleGroup": currentCarSelected.VehicleGroup.Group,
        "CheckIn": data.formData.dropoffDate + " " + data.formData.dropoffTime,
        "CheckOut": data.formData.pickupDate + " " + data.formData.pickupTime,
        "DeliveryPlace": data.formData.pickupPlace,
        "CollectionPlace": data.formData.dropOffPlace,
        "GeneralRemarks": "",
        "PickupRemarks":  data.driverInfo.remarks,
        "POAMarkup": 0,
        "DiscountCoupon": "",
        "DiscountAmount": 0,
        "Extras": newExtras
      };

      this.startLoading();

      var reservationUrl = "insertReservation";
      if (this.$store.state.main.reservationType == 'update') {
        reservationUrl = "updateReservation";
        payLoad.ReferenceNo = this.$store.state.main.reservationData.RefNo;
      }


      this.aronPost(
        reservationUrl,
        { payload: payLoad },
        "",
        ""
      )
        .then((response) => {
          if (response.status) {
            this.$store.state.main.reservation = response.data.reservation;
            this.$router.replace("/confirmation");
          } else {
            this.errorAlert("Error", response.data.error);
          }
          this.isReady = true;
          this.stopLoading();
        })
        .catch((error) => {
          console.log("error:", error);
          this.stopLoading();
          this.isReady = true;
        });
    },


    calculateTotalPrice() {
      this.carRentPrice = this.selectedCar.Charges.Calculation.UnitAmount * this.selectedCar.Charges.Calculation.Quantity
      var days = this.selectedCar.Charges.Calculation.Quantity;
      var totalPrice = 0;
      totalPrice = this.selectedCar.Charges.Calculation.UnitAmount * days;
      let extrasPrice = 0;
      if (this.extras) {
        for (let i = 0; i < this.extras.length; i++) {
          extrasPrice += this.extras[i].Total * this.extras[i].Quantity;
        }
      }
      let requiredPrice = 0;
      if (this.requiredExtras) {
        for (let i = 0; i < this.requiredExtras.length; i++) {
          requiredPrice += this.requiredExtras[i].Charge * this.requiredExtras[i].Quantity;
          //if Functionality is equal to AirportCharge then set a state to true
          if (this.requiredExtras[i].Functionality == "AirportCharge") {
            this.$store.state.main.bookingDetails.isAirportCharge = true;
          }
        }
      }

      totalPrice += extrasPrice + requiredPrice;

      this.$store.state.main.bookingDetails.pickUpAndDropOffTiming.totalPrice =
        totalPrice;
      return { days, totalPrice };
    },
    checkIfDataAvilable() {
      if (Object.keys(this.$store.state.main.currentCarSelected).length === 0) {
        this.$router.push("/booking");
      }
    },

    formatPrice(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  components: {
    location,
    FormWizard,
    TabContent,
    cardCarDetails,
    extras,
    dropDown,
    driverDetails,
    billingAddress,
    CreditCard,
    termsAndCondition,
  },
  computed: {
    ...mapState({
      storeExtras: (state) => state.main.extras,
    }),

    totalDays() {
      return this.$store.state.main.bookingDetails.pickUpAndDropOffTiming
        .totalDays;
    },
    extraHours() {
      return this.$store.state.main.bookingDetails.pickUpAndDropOffTiming
        .extraHours;
    },
    formattedDateTime() {
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        const months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        return `${days[date.getDay()]}, ${date.getDate()} ${months[date.getMonth()]
          } ${date.getFullYear()}`;
      };

      const formatTime = (timeString) => {
        const [hours, minutes] = timeString.split(":");
        const ampm = hours >= 12 ? "PM" : "AM";
        const hour = hours % 12 || 12;
        return `${hour}:${minutes} ${ampm}`;
      };

      const bookingDetails = this.$store.state.main.bookingDetails.formData;

      const pickupDateTime = `${formatDate(
        bookingDetails.pickupDate
      )}, ${formatTime(bookingDetails.pickupTime)}`;
      const dropoffDateTime = `${formatDate(
        bookingDetails.dropoffDate
      )}, ${formatTime(bookingDetails.dropoffTime)}`;

      return { pickupDateTime, dropoffDateTime };
    },
  },


  mounted() {
    this.$store.state.main.bookingDetails.isAirportCharge = false;
    this.checkIfDataAvilable();
    this.calculateTotalPrice();
  },
};
</script>
<style scoped>
.timeline::before {
  content: "";
  position: absolute;
  top: 2rem;
  /* Adjust top position to align with the bottom of the first circle */
  bottom: 4rem;
  /* Adjust bottom position to align with the top of the last circle */
  left: 0.5rem;
  /* Adjust left position to align with the center of the circles */
  width: 1px;
  background-color: black;
  height: 70px;
}
</style>
